import React, { useState, useRef, useEffect, useCallback } from 'react';
import dollars from '../../dollar-format';
import { Link } from "react-router";
import AgentPipelineDetails from "../AgentPipelineDetails/AgentPipelineDetails";
import { executeQuery } from "../../requests/executeQuery";
import { renderPrintFooter } from "../../utils";
import { STRIVE_AGENT_PIPELINE, OA_AGENT_PIPELINE, OLD_STRIVE_AGENT_PIPELINE } from '../../consts/queries';
import { OVERFLOW_TABLE_WIDTH } from '../../consts/tables';
import { agentPipelineChartOptions as defaultChartOptions } from "./chartOptions";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import highcharts3D from 'highcharts/highcharts-3d.src';
import statusColors from '../../status-colors';
import { GET_OA_AGENT_PIPELINE_DEV, GET_OLD_STRIVE_AGENT_PIPELINE_DEV, GET_STRIVE_AGENT_PIPELINE } from '../Graphql/Queries/AgentPipelineQuery';
import { mapToOldResponse } from '../ResponseConversion/GetOldResponse';
import { fetchData } from '../Service/graphQlService';
import ReusableSpinner from '../ReactTable/ReusableSpinner';
import { useApolloClient } from '@apollo/client';

highcharts3D(Highcharts);
Highcharts.setOptions({
    lang: {
        decimalPoint: '.',
        thousandsSep: ',',
    }
});

const AgentPipeline = (props) => {
  const initializeRow = () => {
    return {
        id: 0,
        activeCount: 0,
        activePrice: 0,
        grossPotentialFee: 0,
        negCount: 0,
        negPrice: 0,
        negGrossFee: 0,
        ucCount: 0,
        ucPrice: 0,
        ucGrossFee: 0,
        closedCount: 0,
        closedPrice: 0,
        closedGrossFee: 0,
        currentAgentData: {},
        noDataFound: false,
        contactId: 0,
    }
};
  const [width, setWidth] = useState(1400);
  const [isPrint, setIsPrint] = useState(false);
  const [printBackground, setPrintBackground] = useState('');
  const [loader,setLoader] = useState(true)
const [agentPipelineChartOptions, setAgentPipelineChartOptions] = useState(defaultChartOptions);
const tableHeaderHeight = 48;
  const clientRef = useRef(null);
  const tableRef = useRef(null);
 const client = useApolloClient();
 const OAKey = 'Outside Agent';
const priorKey = 'Prior Agents';
const totalKey = 'Total';
const striveTotalKey = 'STRIVE Total';
const threshold = 1000000;
   const [state, setState] = useState({
    rows: {},
    currentAgentData: {},
    noDataFound: null,
    agentPipelineChartOptions: null,
    height: 0
  });
   if (!clientRef.current) {
    clientRef.current = client;
  }
  // Derive rows depending on agent or not
  const displayRows = props.isAgent ? state.currentAgentData : state.rows;

  // Get currentAgentKeys and agentKey
  const currentAgentKeys = Object.keys(state.currentAgentData);
  const agentKey = props.isAgent && currentAgentKeys.length > 0 ? currentAgentKeys[0] : null;

  // Date formatted MM/DD/YYYY
  const d = new Date();
  const date = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
  const columns = [
    { label: 'Agent', key: 'key' },
    { label: '# of Active Listings', printLabel: '# of Listings', key: 'activeCount', includedKeys: [OAKey, priorKey, striveTotalKey], type: 'number' },
    { label: 'Total Price', key: 'activePrice', includedKeys: [OAKey, priorKey, striveTotalKey], type: 'dollar' },
    { label: 'Gross Potential Fee', key: 'grossPotentialFee', includedKeys: [OAKey, priorKey, striveTotalKey], type: 'dollar', shownInChart: true, color: statusColors['Active'] },
    { label: '# of In Negotiation', printLabel: '# of In Neg', key: 'negCount', includedKeys: [priorKey, striveTotalKey], type: 'number' },
    { label: 'In Negotiation', key: 'negPrice', includedKeys: [priorKey, striveTotalKey], type: 'dollar' },
    { label: 'Gross Fee - In Negotiation', printLabel: 'Gross Fee - In Neg', key: 'negGrossFee', includedKeys: [priorKey], type: 'dollar', shownInChart: true, color: statusColors['In Negotiation'] },
    { label: '# of Under Contract', printLabel: '# of UC', key: 'ucCount', includedKeys: [priorKey, striveTotalKey], type: 'number' },
    { label: 'Under Contract', key: 'ucPrice', includedKeys: [priorKey, striveTotalKey], type: 'dollar' },
    { label: 'Gross Fee - Under Contract', printLabel: 'Gross Fee - UC', key: 'ucGrossFee', includedKeys: [priorKey], type: 'dollar', shownInChart: true, color: statusColors['Under Contract'] },
    { label: '# Closed YTD', key: 'closedCount', includedKeys: [priorKey, striveTotalKey], type: 'number' },
    { label: 'Closed', key: 'closedPrice', includedKeys: [priorKey, striveTotalKey], type: 'dollar' },
    { label: 'Gross Fee - Closed', key: 'closedGrossFee', includedKeys: [priorKey], type: 'dollar', shownInChart: true, color: statusColors['Closed'] },
  ];
  function buildData(stateRows, data, status) {
  const rows = { ...stateRows };

  data.forEach(row => {
    const fullName = row.AGENT_LAST_NAME + row.AGENT_FIRST_NAME;

    if (!rows[fullName]) {
      rows[fullName] = initializeRow();
    }

    if (!rows[fullName].id) {
      rows[fullName].id = row.AGENT_ID;
    }
    if (!rows[fullName].email) {
      rows[fullName].email = row.AGENT_EMAIL;
    }
    if (!rows[fullName].name) {
      rows[fullName].name =
        row.AGENT_FIRST_NAME && row.AGENT_LAST_NAME
          ? row.AGENT_FIRST_NAME.charAt(0).toUpperCase() + ". " + row.AGENT_LAST_NAME
          : "";
    }
    if (!rows[fullName].lastName) {
      rows[fullName].lastName = row.AGENT_LAST_NAME || "";
    }
    if (!rows[fullName].contactId) {
      rows[fullName].contactId = row.CONTACT_ID;
    }

    switch (status) {
      case 'Active':
        rows[fullName].activeCount =
          parseFloat(row.TOTAL_LISTING_COUNT || '0') +
          parseFloat(row.TOTAL_BUYING_COUNT || '0');
        rows[fullName].activePrice = parseFloat(row.TOTAL_LIST_PRICE || '0');
        rows[fullName].grossPotentialFee =
          parseFloat(row.LISTING_GROSS_FEE || '0') +
          parseFloat(row.BUYING_GROSS_FEE || '0');
        break;

      case 'In Negotiation':
        rows[fullName].negCount =
          parseFloat(row.TOTAL_LISTING_COUNT || '0') +
          parseFloat(row.TOTAL_BUYING_COUNT || '0');
        rows[fullName].negPrice =
          parseFloat(row.TOTAL_LISTING_NEGOTIATION_PRICE || '0') +
          parseFloat(row.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
        rows[fullName].negGrossFee =
          parseFloat(row.LISTING_NEGOTIATION_GROSS_FEE || '0') +
          parseFloat(row.BUYING_NEGOTIATION_GROSS_FEE || '0');
        break;

      case 'Under Contract':
        rows[fullName].ucCount =
          parseFloat(row.TOTAL_LISTING_COUNT || '0') +
          parseFloat(row.TOTAL_BUYING_COUNT || '0');
        rows[fullName].ucPrice =
          parseFloat(row.TOTAL_LISTING_NEGOTIATION_PRICE || '0') +
          parseFloat(row.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
        rows[fullName].ucGrossFee =
          parseFloat(row.LISTING_NEGOTIATION_GROSS_FEE || '0') +
          parseFloat(row.BUYING_NEGOTIATION_GROSS_FEE || '0');
        break;

      case 'Closed':
        rows[fullName].closedCount =
          parseFloat(row.TOTAL_LISTING_CLOSED_COUNT || '0') +
          parseFloat(row.TOTAL_BUYING_CLOSED_COUNT || '0');
        rows[fullName].closedPrice =
          parseFloat(row.TOTAL_LISTING_CLOSED_PRICE || '0') +
          parseFloat(row.TOTAL_BUYING_CLOSED_PRICE || '0');
        rows[fullName].closedGrossFee =
          parseFloat(row.LISTING_CLOSED_GROSS_FEE || '0') +
          parseFloat(row.BUYING_CLOSED_GROSS_FEE || '0') +
          parseFloat(row.CLOSED_REFERRAL_FEE || '0');
        break;

      default:
        break;
    }
  });

  return rows;
}

function buildOAData(stateRows, data, status, key) {
  const rows = { ...stateRows };

  if (!rows[key]) {
    rows[key] = initializeRow();
  }

  switch (status) {
    case 'In Negotiation':
      rows[key].negCount =
        parseFloat(data.TOTAL_LISTING_COUNT || '0') +
        parseFloat(data.TOTAL_BUYING_COUNT || '0');
      rows[key].negPrice =
        parseFloat(data.TOTAL_LISTING_NEGOTIATION_PRICE || '0') +
        parseFloat(data.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
      rows[key].negGrossFee =
        parseFloat(data.LISTING_NEGOTIATION_GROSS_FEE || '0') +
        parseFloat(data.BUYING_NEGOTIATION_GROSS_FEE || '0');
      break;

    case 'Under Contract':
      rows[key].ucCount =
        parseFloat(data.TOTAL_LISTING_COUNT || '0') +
        parseFloat(data.TOTAL_BUYING_COUNT || '0');
      rows[key].ucPrice =
        parseFloat(data.TOTAL_LISTING_NEGOTIATION_PRICE || '0') +
        parseFloat(data.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
      rows[key].ucGrossFee =
        parseFloat(data.LISTING_NEGOTIATION_GROSS_FEE || '0') +
        parseFloat(data.BUYING_NEGOTIATION_GROSS_FEE || '0');
      break;

    case 'Closed':
      rows[key].closedCount =
        parseFloat(data.TOTAL_LISTING_CLOSED_COUNT || '0') +
        parseFloat(data.TOTAL_BUYING_CLOSED_COUNT || '0');
      rows[key].closedPrice =
        parseFloat(data.TOTAL_LISTING_CLOSED_PRICE || '0') +
        parseFloat(data.TOTAL_BUYING_CLOSED_PRICE || '0');
      rows[key].closedGrossFee =
        parseFloat(data.LISTING_CLOSED_GROSS_FEE || '0') +
        parseFloat(data.BUYING_CLOSED_GROSS_FEE || '0');
      break;

    default:
      break;
  }

  return rows;
}
function buildTotalData(stateRows) {
  const rows = {
    ...stateRows,
    [totalKey]: initializeRow(),
    [striveTotalKey]: initializeRow()
  };

  Object.keys(rows[totalKey]).forEach((columnKey) => {
    if (columnKey !== "id") {
      rows[totalKey][columnKey] = Object.keys(rows)
      .reduce(
        (previous, key) =>
          previous +
          (typeof rows[key][columnKey] === "string"
            ? parseFloat(rows[key][columnKey])
            : rows[key][columnKey]),
        0
      );
    }
  });

  rows[striveTotalKey].negGrossFee = rows[totalKey].negGrossFee - (rows[OAKey] && rows[OAKey].negGrossFee ? rows[OAKey].negGrossFee : 0);
rows[striveTotalKey].ucGrossFee = rows[totalKey].ucGrossFee - (rows[OAKey] && rows[OAKey].ucGrossFee ? rows[OAKey].ucGrossFee : 0);
rows[striveTotalKey].closedGrossFee = rows[totalKey].closedGrossFee - (rows[OAKey] && rows[OAKey].closedGrossFee ? rows[OAKey].closedGrossFee : 0);

  return rows;
}

function verifyThreshold(series) {
  for (let index = 0; index < series.length; index++) {
    const thresholdPassed = series[index].data.some(value => value > threshold);
    if (thresholdPassed) return true;
  }
  return false;
}

function buildChartOptions({ rows, isAgent, currentAgentData }) {
  const chartRows = isAgent ? currentAgentData : rows;

  if (chartRows) {
    let stateAgentPipelineChartOptions = {};
    const chartRowKeys = Object.keys(chartRows).filter(
      key => key !== priorKey && key !== totalKey && key !== striveTotalKey
    );

    const chartColumns = columns.filter(column => column.shownInChart);
    stateAgentPipelineChartOptions = agentPipelineChartOptions;

    stateAgentPipelineChartOptions.xAxis.categories = chartRowKeys;

    chartColumns.map((column, index) => {
      stateAgentPipelineChartOptions.series[index] = {
        name: column.label,
        color: column.color,
        data: chartRowKeys.map(key => chartRows[key][column.key])
      };
    });

    if (isAgent) {
      const thresholdPassed = verifyThreshold(stateAgentPipelineChartOptions.series);

      stateAgentPipelineChartOptions.chart.options3d.depth = 60;
      stateAgentPipelineChartOptions.chart.width = 790;
      stateAgentPipelineChartOptions.chart.height = 500;
      stateAgentPipelineChartOptions.yAxis.tickInterval = thresholdPassed ? 500000 : 100000;
      stateAgentPipelineChartOptions.plotOptions.column.depth = 60;
      stateAgentPipelineChartOptions.plotOptions.column.pointWidth = 40;
    }

    return stateAgentPipelineChartOptions;
  }

  return null;
}

const fetch = useCallback((client) => {
  const token = localStorage.getItem('authToken');

  if (client) {
    Promise.all([
      fetchData(GET_STRIVE_AGENT_PIPELINE, { status: 'Active' }),
      fetchData(GET_STRIVE_AGENT_PIPELINE, { status: 'In Negotiation' }),
      fetchData(GET_STRIVE_AGENT_PIPELINE, { status: 'Under Contract' }),
      fetchData(GET_STRIVE_AGENT_PIPELINE, { status: 'Closed' }),
      fetchData(GET_OA_AGENT_PIPELINE_DEV, { status: 'In Negotiation' }),
      fetchData(GET_OA_AGENT_PIPELINE_DEV, { status: 'Under Contract' }),
      fetchData(GET_OA_AGENT_PIPELINE_DEV, { status: 'Closed' }),
      fetchData(GET_OLD_STRIVE_AGENT_PIPELINE_DEV, {})
    ]).then(res => {
      if(res.length > 0 ){
        setLoader(false)
      } 
      var responses = mapToOldResponse(res).responses;

      if (
        res &&
        responses[0] && responses[0].success && Array.isArray(responses[0].data[0].STRIVEAGENTPIPELINE.DATA) &&
        responses[1] && responses[1].success && Array.isArray(responses[1].data[0].STRIVEAGENTPIPELINE.DATA) &&
        responses[2] && responses[2].success && Array.isArray(responses[2].data[0].STRIVEAGENTPIPELINE.DATA) &&
        responses[3] && responses[3].success && Array.isArray(responses[3].data[0].STRIVEAGENTPIPELINE.DATA) &&
        responses[4] && responses[4].success && Array.isArray(responses[4].data[0].OAAGENTPIPELINE.DATA) &&
        responses[5] && responses[5].success && Array.isArray(responses[5].data[0].OAAGENTPIPELINE.DATA) &&
        responses[6] && responses[6].success && Array.isArray(responses[6].data[0].OAAGENTPIPELINE.DATA) &&
        responses[7] && responses[7].success && Array.isArray(responses[7].data[0].OLDSTRIVEAGENTPIPELINE.DATA)
      ) {
        const activeData = responses[0].data[0].STRIVEAGENTPIPELINE.DATA;
        const negData = responses[1].data[0].STRIVEAGENTPIPELINE.DATA;
        const ucData = responses[2].data[0].STRIVEAGENTPIPELINE.DATA;
        const closedData = responses[3].data[0].STRIVEAGENTPIPELINE.DATA;

        let rows = { ...state.rows };
        rows = buildData(rows, activeData, 'Active');
        rows = buildData(rows, negData, 'In Negotiation');
        rows = buildData(rows, ucData, 'Under Contract');
        rows = buildData(rows, closedData, 'Closed');

        rows = Object.fromEntries(
  Object.entries(rows).sort((a, b) => {
    const aLastName = (a[1].lastName && typeof a[1].lastName === 'string') ? a[1].lastName : '';
    const bLastName = (b[1].lastName && typeof b[1].lastName === 'string') ? b[1].lastName : '';

    const lastNameComparison = aLastName.localeCompare(bLastName);

    if (lastNameComparison === 0) {
      const aName = (a[1].name && typeof a[1].name === 'string') ? a[1].name : '';
      const bName = (b[1].name && typeof b[1].name === 'string') ? b[1].name : '';

      return aName.localeCompare(bName);
    }

    return lastNameComparison;
  })
);

        rows = buildOAData(rows, responses[4].data[0].OAAGENTPIPELINE.DATA[0], 'In Negotiation', OAKey);
        rows = buildOAData(rows, responses[5].data[0].OAAGENTPIPELINE.DATA[0], 'Under Contract', OAKey);
        rows = buildOAData(rows, responses[6].data[0].OAAGENTPIPELINE.DATA[0], 'Closed', OAKey);
        rows = buildOAData(rows, responses[7].data[0].OLDSTRIVEAGENTPIPELINE.DATA[0], 'Closed', priorKey);
        rows = buildTotalData(rows);

    const newState = {
  rows,
  currentAgentData: null,
  noDataFound: null,
  agentPipelineChartOptions: null
};

if (props.isAgent) {
  const currentAgentData = findAgentRow(rows, props.userData.email);
  if (currentAgentData && Object.keys(currentAgentData).length) {
    newState.currentAgentData = currentAgentData;
  } else {
    newState.noDataFound = 'No data available';
  }
}
newState.currentAgentData = newState.currentAgentData !== null ? newState.currentAgentData : {}
newState.agentPipelineChartOptions = buildChartOptions({
  rows,
  isAgent: props.isAgent,
  currentAgentData: newState.currentAgentData
});
        setState(prev => ({ ...prev, ...newState  }));

          const headerHeight = 40;
          const headDetailsHeight = 116;
          const bottomSpaceHeight = 30;
          let height = window.innerHeight - headerHeight - headDetailsHeight - bottomSpaceHeight;

          if (
            tableRef.current &&
            tableRef.current.clientHeight &&
            height > tableRef.current.clientHeight &&
            tableRef.current.clientHeight >= tableHeaderHeight
          ) {
            height = tableRef.current.clientHeight + (props.isAgent ? 0 : 15);
          }

          setState(prev => ({ ...prev, height }));
      }
    }).catch(error => {
      // A failing backend query (e.g. the "inventory yearly" resolver) would
      // otherwise leave Promise.all rejected with no handler, so the loader
      // never clears and the page hangs on an infinite spinner. Surface the
      // error instead of hanging.
      console.error("Error loading Agent Pipeline data:", error && error.message);
      setLoader(false);
      setState(prev => ({ ...prev, noDataFound: 'Unable to load pipeline data. Please try again later.' }));
    });
  }
}, [props.isAgent, props.userData.email, state.rows]); // dependencies used inside fetch
  function updateTableWidth() {
    setWidth(window.innerWidth - OVERFLOW_TABLE_WIDTH);
  }

   useEffect(() => {
    updateTableWidth();

    if (client) {
      setPrintBackground(`url('${arc.path.media + 'Transaction_Background.png'}')`);
      fetch(client);  // call your fetch function here

      window.addEventListener('resize', updateTableWidth);
      window.onbeforeprint = beforePrint;
      window.onafterprint = afterPrint;

      // cleanup event listeners on unmount
      return () => {
        window.removeEventListener('resize', updateTableWidth);
        window.onbeforeprint = null;
        window.onafterprint = null;
      };
    }
  }, [client, arc.path.media,printBackground]);

useEffect(() => {
  // add event listener on mount
  window.addEventListener('resize', updateTableWidth);

  // cleanup on unmount
  return () => {
    window.removeEventListener('resize', updateTableWidth);
  };
}, []);


function beforePrint() {
  setIsPrint(true);
}

function afterPrint() {
  setIsPrint(false);
}
  const displayValue = ({ type, value, key, includedKeys, isPrintTable }) => {
    if (!value) {
      if (includedKeys && includedKeys.includes(key)) {
        return '-';
      }
      switch (type) {
        case 'number': return '0.00';
        case 'dollar': return isPrintTable ? '$0' : '$0.00';
        default: return '';
      }
    }
    switch (type) {
      case 'number': return Number(value).toFixed(2);
      case 'dollar': return isPrintTable ? dollars(parseInt(value)) : dollars(value, true);
      default: return value;
    }
  };

  const renderTable = ({ rows, cols, isAgent, isPrintTable }) => (
    <table className="table" ref={!isPrintTable ? tableRef : null}>
      <thead>
        <tr>
          {cols.map((column, i) => {
            const label = isPrintTable && column.printLabel ? column.printLabel : column.label;
            if (i === 0) return <th key={i} className="AgentPipeline_th border_top border_left" id="AgentPipeline_first_cell">{label}</th>;
            return <th key={i} className="AgentPipeline_th border_top">{label}</th>;
          })}
        </tr>
      </thead>
      <tbody>
        {Object.keys(rows).map(key => {
          if (!rows[key]) return null;
          const extraStyle = key === totalKey ? 'total' : (key === striveTotalKey ? 'strive-total' : '');
          return (
            <tr key={key} className="AgentPipeline_tr">
              {cols.map((column, i) => {
                if (i === 0) {
                  return (
                    <th key={`${key}-${i}`} className={`AgentPipeline_th agents border_left ${extraStyle}`}>
                      {rows[key].id && !isAgent ? (
                        <Link
                          to={{
                            pathname: `${arc.path.base}agent-pipeline/${rows[key].id}`,
                            state: { id: rows[key].id, name: rows[key].name, contactId: rows[key].contactId, fromListUrl: window.location.pathname + window.location.search },
                          }}
                        >
                          {rows[key].name}
                        </Link>
                      ) : (
                        key
                      )}
                    </th>
                  );
                }
                return (
                  <td key={`${key}-${i}`} className={`AgentPipeline_td ${extraStyle}`}>
                    {displayValue({ type: column.type, value: rows[key][column.key], key, includedKeys: column.includedKeys, isPrintTable })}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  const splitObjectIntoChunks = (obj, chunkSize = 15) => {
    const entries = Object.entries(obj);
    return Array.from({ length: Math.ceil(entries.length / chunkSize) }, (_, i) =>
      Object.fromEntries(entries.slice(i * chunkSize, (i + 1) * chunkSize))
    );
  };

  const renderPrintPage = ({ rows, cols, date, isPrint, printBackground }) => {
      // Split rows into chunks
    const rowChunks = splitObjectIntoChunks(rows);
    return (
      <React.Fragment>
        {rowChunks.map((rowChunk, chunkIndex) => (
          <div
            className="print-container"
            style={{ backgroundImage: isPrint && printBackground }}
             key={chunkIndex}
          >
            {chunkIndex === 0 && (
              <div className="AgentPipeline_head_left">
                <h3 className="AgentPipeline_h3">STRIVE Agent Pipeline</h3>
                <h4 className="AgentPipeline_h4">{date}</h4>
              </div>
            )}

            <div className={`table-print-container ${chunkIndex !== 0 ? 'marginTop50' : ''}`}>
              {renderTable({ rows: rowChunk, cols, isPrintTable: true })}
            </div>

            {renderPrintFooter(isPrint)}
          </div>
        ))}
      </React.Fragment>
    );
  };

  return (
    <div className="AgentPipeline">
      {renderPrintPage({ rows: displayRows, cols: columns, date, isPrint, printBackground })}

      <div className="preload-print-background" style={{ backgroundImage: printBackground }} />

      <div className="AgentPipeline_header">
        <h3 className="AgentPipeline_h3">STRIVE Agent Pipeline</h3>
        <h4 className="AgentPipeline_h4">{date}</h4>
      </div>
     <div
  className="AgentPipeline_scroll_container"
  style={{width: width,height:state.height}} 
>
  {renderTable({ rows: displayRows, cols: columns, isAgent: props.isAgent, isPrintTable: false })}
</div>
      {state.agentPipelineChartOptions && (
        <div className="AgentPipeline_chart">
          <HighchartsReact highcharts={Highcharts} options={agentPipelineChartOptions} />
        </div>
      )}

      {state.noDataFound && <div className="no-data">{state.noDataFound}</div>}

      {props.isAgent && agentKey ? (
        <AgentPipelineDetails
          id={currentAgentData[agentKey].id}
          name={currentAgentData[agentKey].name}
          contactId={currentAgentData[agentKey].contactId}
          withoutAgentName={true}
        />
      ) : null }
      {loader && <ReusableSpinner/>}
    </div>
  );
};

export default AgentPipeline;


//  export default class AgentPipeline extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             rows: {},
//             width: 1400,
//             currentAgentData: {},
//             height: tableHeaderHeight,
//             isPrint: false,
//             printBackground: '',
//             agentPipelineChartOptions: null,
//         };
//         this.client = null;
//         this.beforePrint = this.beforePrint.bind(this);
//         this.afterPrint = this.afterPrint.bind(this);
//         this.updateTableWidth = this.updateTableWidth.bind(this);

//         this.tableRef = React.createRef();
//     }

//     static buildData(stateRows, data, status) {
//         const rows = { ...stateRows };

//         data.map(row => {
//             let fullName = row.AGENT_LAST_NAME + row.AGENT_FIRST_NAME
//             if (!rows[fullName]) {
//                 rows[fullName] = initializeRow();
//             }
//             if (!rows[fullName].id) {
//                 rows[fullName].id = row.AGENT_ID;
//             }
//             if (!rows[fullName].email) {
//                 rows[fullName].email = row.AGENT_EMAIL;
//             }
//             if (!rows[fullName].name) {
//                 rows[fullName].name = row.AGENT_FIRST_NAME && row.AGENT_LAST_NAME ? row.AGENT_FIRST_NAME.charAt(0).toUpperCase() + ". " + row.AGENT_LAST_NAME : "";
//             }
//             if (!rows[fullName].lastName) {
//                 rows[fullName].lastName = row.AGENT_LAST_NAME && row.AGENT_LAST_NAME;
//             }
//             if (!rows[fullName].contactId) {
//                 rows[fullName].contactId = row.CONTACT_ID;
//             }

//             switch (status) {
//                 case 'Active': {
//                     rows[fullName].activeCount = parseFloat(row.TOTAL_LISTING_COUNT || '0') + parseFloat(row.TOTAL_BUYING_COUNT || '0');
//                     rows[fullName].activePrice = parseFloat(row.TOTAL_LIST_PRICE || '0');
//                     rows[fullName].grossPotentialFee = parseFloat(row.LISTING_GROSS_FEE || '0') + parseFloat(row.BUYING_GROSS_FEE || '0');
//                     break;
//                 }
//                 case 'In Negotiation': {
//                     rows[fullName].negCount = parseFloat(row.TOTAL_LISTING_COUNT || '0') + parseFloat(row.TOTAL_BUYING_COUNT || '0');
//                     rows[fullName].negPrice = parseFloat(row.TOTAL_LISTING_NEGOTIATION_PRICE || '0') + parseFloat(row.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
//                     rows[fullName].negGrossFee = parseFloat(row.LISTING_NEGOTIATION_GROSS_FEE || '0') + parseFloat(row.BUYING_NEGOTIATION_GROSS_FEE || '0');
//                     break;
//                 }
//                 case 'Under Contract': {
//                     rows[fullName].ucCount = parseFloat(row.TOTAL_LISTING_COUNT || '0') + parseFloat(row.TOTAL_BUYING_COUNT || '0');
//                     rows[fullName].ucPrice = parseFloat(row.TOTAL_LISTING_NEGOTIATION_PRICE || '0') + parseFloat(row.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
//                     rows[fullName].ucGrossFee = parseFloat(row.LISTING_NEGOTIATION_GROSS_FEE || '0') + parseFloat(row.BUYING_NEGOTIATION_GROSS_FEE || '0');
//                     break;
//                 }
//                 case 'Closed': {
//                     rows[fullName].closedCount = parseFloat(row.TOTAL_LISTING_CLOSED_COUNT || '0') + parseFloat(row.TOTAL_BUYING_CLOSED_COUNT || '0');
//                     rows[fullName].closedPrice = parseFloat(row.TOTAL_LISTING_CLOSED_PRICE || '0') + parseFloat(row.TOTAL_BUYING_CLOSED_PRICE || '0');
//                     rows[fullName].closedGrossFee = parseFloat(row.LISTING_CLOSED_GROSS_FEE || '0') + parseFloat(row.BUYING_CLOSED_GROSS_FEE || '0') + parseFloat(row.CLOSED_REFERRAL_FEE || '0');
//                     break;
//                 }
//             }
//         });

//         return rows;
//     }

//     static buildOAData(stateRows, data, status, key) {
//         const rows = { ...stateRows };

//         if (!rows[key]) {
//             rows[key] = initializeRow();
//         }

//         switch (status) {
//             case 'In Negotiation': {
//                 rows[key].negCount = parseFloat(data.TOTAL_LISTING_COUNT || '0') + parseFloat(data.TOTAL_BUYING_COUNT || '0');
//                 rows[key].negPrice = parseFloat(data.TOTAL_LISTING_NEGOTIATION_PRICE || '0') + parseFloat(data.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
//                 rows[key].negGrossFee = parseFloat(data.LISTING_NEGOTIATION_GROSS_FEE || '0') + parseFloat(data.BUYING_NEGOTIATION_GROSS_FEE || '0');
//                 break;
//             }
//             case 'Under Contract': {
//                 rows[key].ucCount = parseFloat(data.TOTAL_LISTING_COUNT || '0') + parseFloat(data.TOTAL_BUYING_COUNT || '0');
//                 rows[key].ucPrice = parseFloat(data.TOTAL_LISTING_NEGOTIATION_PRICE || '0') + parseFloat(data.TOTAL_BUYING_NEGOTIATION_PRICE || '0');
//                 rows[key].ucGrossFee = parseFloat(data.LISTING_NEGOTIATION_GROSS_FEE || '0') + parseFloat(data.BUYING_NEGOTIATION_GROSS_FEE || '0');
//                 break;
//             }
//             case 'Closed': {
//                 rows[key].closedCount = parseFloat(data.TOTAL_LISTING_CLOSED_COUNT || '0') + parseFloat(data.TOTAL_BUYING_CLOSED_COUNT || '0');
//                 rows[key].closedPrice = parseFloat(data.TOTAL_LISTING_CLOSED_PRICE || '0') + parseFloat(data.TOTAL_BUYING_CLOSED_PRICE || '0');
//                 rows[key].closedGrossFee = parseFloat(data.LISTING_CLOSED_GROSS_FEE || '0') + parseFloat(data.BUYING_CLOSED_GROSS_FEE || '0');
//                 break;
//             }
//         }

//         return rows;
//     }

//     static buildTotalData(stateRows) {
//         const rows = { ...stateRows, [totalKey]: initializeRow(), [striveTotalKey]: initializeRow() };
//         Object.keys(rows[totalKey]).map(columnKey => {
         
//             if (columnKey !== "id") {
//                 rows[totalKey][columnKey] = Object.keys(rows)
//                     .reduce((previous, key) => previous + (typeof rows[key][columnKey] === 'string' ? parseFloat(rows[key][columnKey]) : rows[key][columnKey]), 0);
//             }
//         });
//         rows[striveTotalKey].negGrossFee = rows[totalKey].negGrossFee - rows[OAKey].negGrossFee;
//         rows[striveTotalKey].ucGrossFee = rows[totalKey].ucGrossFee - rows[OAKey].ucGrossFee;
//         rows[striveTotalKey].closedGrossFee = rows[totalKey].closedGrossFee - rows[OAKey].closedGrossFee;
//         return rows;
//     }

//     static verifyThreshold(series) {
//         for (let index = 0; index < series.length; index++) {
//             const thresholdPassed = !!series[index].data.filter(value => value > threshold).length;
//             if (thresholdPassed) return true;
//         }
//         return false;
//     }

//     static buildChartOptions({ rows, isAgent, currentAgentData }) {
//         const chartRows = isAgent ? currentAgentData : rows;
//         if (chartRows) {
//             let stateAgentPipelineChartOptions = {};
//             const chartRowKeys = Object.keys(chartRows).filter(key => ![priorKey, totalKey, striveTotalKey].includes(key));
//             const chartColumns = columns.filter(column => column.shownInChart);
//             stateAgentPipelineChartOptions = agentPipelineChartOptions;
//             stateAgentPipelineChartOptions.xAxis.categories = chartRowKeys;

//             chartColumns.map((column, index) => {
//                 stateAgentPipelineChartOptions.series[index] = {
//                     name: column.label,
//                     color: column.color,
//                     data: chartRowKeys.map(key => chartRows[key][column.key]),
//                 }
//             });

//             if (isAgent) {
//                 const thresholdPassed = AgentPipeline.verifyThreshold(stateAgentPipelineChartOptions.series);
//                 stateAgentPipelineChartOptions.chart.options3d.depth = 60;
//                 stateAgentPipelineChartOptions.chart.width = 790;
//                 stateAgentPipelineChartOptions.chart.height = 500;
//                 stateAgentPipelineChartOptions.yAxis.tickInterval = thresholdPassed ? 500000 : 100000;
//                 stateAgentPipelineChartOptions.plotOptions.column.depth = 60;
//                 stateAgentPipelineChartOptions.plotOptions.column.pointWidth = 40;
//             }

//             return stateAgentPipelineChartOptions;
//         }

//         return null;
//     }

//     fetch() {
//         const token = localStorage.getItem('authToken');
//         if(this.client){
//             Promise.all([

//                            fetchData( GET_STRIVE_AGENT_PIPELINE,  { status: 'Active' }),
//                            fetchData( GET_STRIVE_AGENT_PIPELINE,  { status: 'In Negotiation' }),
//                            fetchData( GET_STRIVE_AGENT_PIPELINE,  { status: 'Under Contract' }),
//                            fetchData( GET_STRIVE_AGENT_PIPELINE,  { status: 'Closed' }),
//                            fetchData( GET_OA_AGENT_PIPELINE_DEV,  { status: 'In Negotiation' }),
//                            fetchData( GET_OA_AGENT_PIPELINE_DEV,  { status: 'Under Contract' }),
//                            fetchData( GET_OA_AGENT_PIPELINE_DEV,  { status: 'Closed' }),
//                            fetchData( GET_OLD_STRIVE_AGENT_PIPELINE_DEV,{})
//             ]).then(res => {
//                 var responses = mapToOldResponse(res).responses;
//                 if (

//                     res && responses[0] && responses[0].success && Array.isArray(responses[0].data[0].STRIVEAGENTPIPELINE.DATA) &&
//                     responses[1] && responses[1].success && Array.isArray(responses[1].data[0].STRIVEAGENTPIPELINE.DATA) &&
//                     responses[2] && responses[2].success && Array.isArray(responses[2].data[0].STRIVEAGENTPIPELINE.DATA) &&
//                     responses[3] && responses[3].success && Array.isArray(responses[3].data[0].STRIVEAGENTPIPELINE.DATA) &&
//                     responses[4] && responses[4].success && Array.isArray(responses[4].data[0].OAAGENTPIPELINE.DATA) &&
//                     responses[5] && responses[5].success && Array.isArray(responses[5].data[0].OAAGENTPIPELINE.DATA) &&
//                     responses[6] && responses[6].success && Array.isArray(responses[6].data[0].OAAGENTPIPELINE.DATA) &&
//                     responses[7] && responses[7].success && Array.isArray(responses[7].data[0].OLDSTRIVEAGENTPIPELINE.DATA)) 
//                     {
//                     const activeData = responses[0].data[0].STRIVEAGENTPIPELINE.DATA;
//                     const negData = responses[1].data[0].STRIVEAGENTPIPELINE.DATA;
//                     const ucData = responses[2].data[0].STRIVEAGENTPIPELINE.DATA;
//                     const closedData = responses[3].data[0].STRIVEAGENTPIPELINE.DATA;
//                     let rows = { ...this.state.rows };
//                     rows = AgentPipeline.buildData(rows, activeData, 'Active');
//                     rows = AgentPipeline.buildData(rows, negData, 'In Negotiation');
//                     rows = AgentPipeline.buildData(rows, ucData, 'Under Contract');
//                     rows = AgentPipeline.buildData(rows, closedData, 'Closed');
//                     // Sort Order based on Agent First Name
//                     //rows = Object.fromEntries(Object.entries(rows).sort((a, b) => a[1].lastName.localeCompare(b[1].lastName)));
//                     rows = Object.fromEntries(Object.entries(rows).sort((a, b) => {
//                         const lastNameComaprision = a[1].lastName.localeCompare(b[1].lastName);
//                         if (lastNameComaprision === 0) {
//                             return a[1].name.localeCompare(b[1].name);
//                         }
//                         return lastNameComaprision;
//                     }));
//                     rows = AgentPipeline.buildOAData(rows, responses[4].data[0].OAAGENTPIPELINE.DATA[0], 'In Negotiation', OAKey);
//                     rows = AgentPipeline.buildOAData(rows, responses[5].data[0].OAAGENTPIPELINE.DATA[0], 'Under Contract', OAKey);
//                     rows = AgentPipeline.buildOAData(rows, responses[6].data[0].OAAGENTPIPELINE.DATA[0], 'Closed', OAKey);
//                     rows = AgentPipeline.buildOAData(rows, responses[7].data[0].OLDSTRIVEAGENTPIPELINE.DATA[0], 'Closed', priorKey);
//                     rows = AgentPipeline.buildTotalData(rows);
    
//                     const state = {
//                         rows,
//                     };
    
//                     if (this.props.isAgent) {
//                         const currentAgentData = findAgentRow(rows, this.props.userData.email);
//                         if (currentAgentData && Object.keys(currentAgentData).length) {
//                             state.currentAgentData = currentAgentData;
//                         } else {
//                             state.noDataFound = 'No data available';
//                         }
//                     }
    
//                     state.agentPipelineChartOptions = AgentPipeline.buildChartOptions({ rows, isAgent: this.props.isAgent, currentAgentData: state.currentAgentData });
    
//                     this.setState(state, () => {
//                         const headerHeight = 40;
//                         const headDetailsHeight = 116;
//                         const bottomSpaceHeight = 30;
//                         let height = window.innerHeight - headerHeight - headDetailsHeight - bottomSpaceHeight;
//                         if (height > this.tableRef.current.clientHeight && this.tableRef.current.clientHeight >= tableHeaderHeight) {
//                             height = this.tableRef.current.clientHeight + (this.props.isAgent ? 0 : 15);
//                         }
//                         this.setState({ height });
//                     });
//                 }
//             });
//         }
//     }

//     updateTableWidth() {
//         this.setState({ width: window.innerWidth - OVERFLOW_TABLE_WIDTH });
//     }

//     componentDidMount() {
//         this.updateTableWidth();
//         if(this.client){
//             this.setState({ printBackground: `url('${arc.path.media + 'Transaction_Background.png'}')` }, this.fetch);
//             window.addEventListener('resize', this.updateTableWidth);
//             window.onbeforeprint = this.beforePrint;
//             window.onafterprint = this.afterPrint;
//         }
//     }

//     componentWillUnmount() {
//         window.removeEventListener('resize', this.updateTableWidth);
//     }

//     beforePrint() {
//         this.setState({ isPrint: true });
//     }

//     afterPrint() {
//         this.setState({ isPrint: false });
//     }

//     static displayValue({ type, value, key, includedKeys, isPrintTable }) {
//         if (!value) {
//             if (includedKeys.includes(key))
//                 return '-';

//             switch (type) {
//                 case 'number':
//                     return '0.00';
//                 case 'dollar':
//                     return isPrintTable ? '$0' : '$0.00';
//             }
//         }

//         switch (type) {
//             case 'number':
//                 return Number(value).toFixed(2);
//             case 'dollar':
//                 return isPrintTable ? dollars(parseInt(value)) : dollars(value, true);
//         }
//     }

//     renderTable({ rows, cols, isAgent, isPrintTable }) {
//         return (
//             <table className='table' ref={!isPrintTable ? this.tableRef : null} >
//                 <thead>
//                     <tr>
//                         {
//                             cols.map((column, index) => {
//                                 const label = isPrintTable && column.printLabel ? column.printLabel : column.label;
//                                 if (index === 0)
//                                     return <th key={index} className="AgentPipeline_th border_top border_left" id='AgentPipeline_first_cell'>{label}</th>;
//                                 return <th key={index} className="AgentPipeline_th border_top">{label}</th>
//                             })
//                         }
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {
//                         Object.keys(rows).map(key => {
//                             if (!rows[key]) return;
//                             const extraStyle = key === totalKey ? 'total' : (key === striveTotalKey ? 'strive-total' : '');
//                             return (
//                                 <tr key={key} className="AgentPipeline_tr">
//                                     {
//                                         cols.map((column, index) => {
//                                             if (index === 0)
//                                                 return (
//                                                     <th key={key + '-' + index} className={`AgentPipeline_th agents border_left ${extraStyle}`}>
//                                                         {
//                                                             rows[key].id && !isAgent ?
//                                                                 <Link
//                                                                  to={
//                                                                     { pathname: `${arc.path.base}agent-pipeline/${rows[key].id}`, state: { id: rows[key].id, name: rows[key].name ,contactId: rows[key].contactId}, state: { fromListUrl: window.location.pathname + window.location.search } }
//                                                                     }>{rows[key].name}
//                                                                  </Link>
//                                                                 :
//                                                                 key
//                                                         }
//                                                     </th>
//                                                 );
//                                             return (
//                                                 <td key={key + '-' + index} className={`AgentPipeline_td ${extraStyle}`}>
//                                                     {AgentPipeline.displayValue({ type: column.type, value: rows[key][column.key], key, includedKeys: column.includedKeys, isPrintTable })}
//                                                 </td>
//                                             );
//                                         })
//                                     }
//                                 </tr>
//                             );
//                         })
//                     }
//                 </tbody>
//             </table>
//         );
//     }

//     // renderPrintPage({ rows, cols, date, isPrint, printBackground }) {
//     //     return (
//     //         <div className='print-container' style={{ backgroundImage: isPrint && printBackground }}>
//     //             <div className='AgentPipeline_head_left'>
//     //                 <h3 className='AgentPipeline_h3'>STRIVE Agent Pipeline</h3>
//     //                 <h4 className='AgentPipeline_h4'>{date}</h4>
//     //             </div>
//     //             <div className='table-print-container'>
//     //                 {this.renderTable({ rows, cols, isPrintTable: true })}
//     //             </div>
//     //             {renderPrintFooter(isPrint)}
//     //         </div>
//     //     )
//     // }
//     renderPrintPage({rows, cols, date, isPrint, printBackground}) {

//         const splitObjectIntoChunks = (obj, chunkSize = 15) => {
//             const entries = Object.entries(obj);
//             return Array.from({ length: Math.ceil(entries.length / chunkSize) }, (_, i) =>
//               Object.fromEntries(entries.slice(i * chunkSize, (i + 1) * chunkSize))
//             );
//           };
    
//         // Split rows into chunks
//         const rowChunks = splitObjectIntoChunks(rows);
//         return (
//             <React.Fragment>
//             {rowChunks.map((rowChunk, chunkIndex) => (
                
//             <div className='print-container' style={{backgroundImage: isPrint && printBackground}} key={chunkIndex}>
//                 {chunkIndex === 0 && <div className='AgentPipeline_head_left'>
//                     <h3 className='AgentPipeline_h3'>STRIVE Agent Pipeline</h3>
//                     <h4 className='AgentPipeline_h4'>{date}</h4>
//                 </div>}
//                 <div className={`table-print-container ${chunkIndex !== 0 && 'marginTop50'}`}>
//                     {this.renderTable({rows: rowChunk, cols, isPrintTable: true})}
//                 </div>
//                 {renderPrintFooter(isPrint)}
//             </div>
           
//              ))}
//               </React.Fragment>
//         )
//     }

//     render() {
//         const isAgent = this.props.isAgent;
//         const { agentPipelineChartOptions, currentAgentData, isPrint, printBackground } = this.state;
//         const rows = isAgent ? currentAgentData : this.state.rows;
//         const currentAgentKeys = Object.keys(currentAgentData);
//         const agentKey = isAgent && currentAgentKeys.length && currentAgentKeys[0];
//         const noDataFound = this.state.noDataFound;
//         const d = new Date();
//         const date = d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();

//         return (
//             <ApolloConsumer>
//                 {client => {
//                     if (!this.client) {
//                         this.client = client;
//                     }
//                     return (
//                         <div className='AgentPipeline'>
//                             {this.renderPrintPage({ rows, cols: columns, date, isPrint, printBackground })}
//                             <div className='preload-print-background' style={{ backgroundImage: printBackground }} />

//                             <div className='AgentPipeline_header'>
//                                 <h3 className='AgentPipeline_h3'>STRIVE Agent Pipeline</h3>
//                                 <h4 className='AgentPipeline_h4'>{date}</h4>
//                             </div>
//                             <div className='AgentPipeline_scroll_container' style={{ width: this.state.width, height: this.state.height }}>
//                                 {this.renderTable({ rows, cols: columns, isAgent, isPrintTable: false })}
//                             </div>
//                             {agentPipelineChartOptions &&
//                                 <div className='AgentPipeline_chart'>
//                                     <HighchartsReact
//                                         highcharts={Highcharts}
//                                         options={agentPipelineChartOptions}
//                                     />
//                                 </div>
//                             }
//                             {noDataFound ? <div className='no-data'>{noDataFound}</div> : null}
//                             {isAgent && agentKey ? <AgentPipelineDetails id={currentAgentData[agentKey].id} name={currentAgentData[agentKey].name} contactId={currentAgentData[agentKey].contactId} withoutAgentName={true} /> : null}
//                         </div>
//                     )
//                 }}
//             </ApolloConsumer>
//         );
//     }
// }